import ComingSoon from '../../components/common/ComingSoon/ComingSoon'
import DocumentHeader from '../../components/Helmet/DocumentHeader'
import { HeaderConstants } from '../../constants/HeaderConstants'
import React from 'react'

const HealthStatus = () => {
  return (
    <>
      <DocumentHeader header={HeaderConstants.HEALTH_STATUS} />
      <ComingSoon />
    </>
  )
}

export default HealthStatus
